import { Tag } from 'types/lead-management';

export type ApiBranchTag = Omit<Tag, 'id'> & { id: number };

export const isUserAssignable = (tag: Tag) => tag.is_user_assignable !== false;

export const toUiTag = (tag: ApiBranchTag): Tag => ({
  ...tag,
  id: String(tag.id)
});

export const toUiTags = (tags?: Array<Tag | ApiBranchTag>): Tag[] =>
  (tags ?? []).map((tag) => ({ ...tag, id: String(tag.id) }));

export const toTagIds = (tags: Tag[]) =>
  tags
    .filter(isUserAssignable)
    .map((tag) => Number(tag.id))
    .filter((id) => !Number.isNaN(id));

export const tagsChanged = (current: Tag[], next: Tag[]) => {
  const currentIds = toTagIds(current).sort((a, b) => a - b);
  const nextIds = toTagIds(next).sort((a, b) => a - b);
  return (
    currentIds.length !== nextIds.length ||
    currentIds.some((id, index) => id !== nextIds[index])
  );
};

export const replaceTag = (tags: Tag[], oldId: string, updated: Tag) =>
  tags.map((tag) => (tag.id === oldId ? updated : tag));
